// PersistGate renders `loading` until redux-persist has restored the store.
// Starting the real client app while the gate is still rendering `null`
// creates an empty first pass. Keep the SSR page visible until the gate can
// render the application immediately.
export const runAfterPersistenceRehydration = (persistor, callback) => {
  let completed = false;
  let unsubscribe = () => {};

  const runOnceWhenReady = () => {
    if (completed || !persistor.getState().bootstrapped) return;

    completed = true;
    unsubscribe();
    callback();
  };

  if (persistor.getState().bootstrapped) {
    runOnceWhenReady();
    return () => {};
  }

  unsubscribe = persistor.subscribe(runOnceWhenReady);
  // Cover a bootstrap that completed between the first state read and the
  // subscription being registered.
  runOnceWhenReady();

  return () => {
    completed = true;
    unsubscribe();
  };
};

export const replaceSsrWithClientApp = (rootElement, createRoot, app) => {
  if (!rootElement) throw new Error("Cannot mount the client app without #root");

  rootElement.replaceChildren();
  createRoot(rootElement).render(app);
};
